import React from "react";
import "./NavBar.css";
const navbar = () => {
  const offSetClick = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute("href");
    const element = document.querySelector(target).offsetTop;
    window.scrollTo({ left: 0, top: element - 80 });
  };
  return (
    <nav class="topnav">
      <div className="leftSide">
        <article className="stacked">
          <article className="logo">KD</article>
          <article className="name">Karim Darrag</article>
        </article>
      </div>
      <div className="center">
        <a href="#home">
          {" "}
          <div className="link">Home</div>
        </a>
        <a href="#experience">
          {" "}
          <div className="link">Experience</div>
        </a>
        <a href="#projects">
          {" "}
          <div className="link">Projects</div>
        </a>
        <a href="#footer">
          {" "}
          <div className="link">Contact</div>
        </a>
      </div>
      <div className="rightSide">
        <a
          style={{ color: "indianred" }}
          rel="noreferrer"
          target="_blank"
          href="https://www.linkedin.com/in/karim-darrag/"
        >
          <i class="fa fa-linkedin-square" style={{ "font-size": "30px" }}></i>
        </a>
        <a
          style={{ color: "indianred" }}
          rel="noreferrer"
          target="_blank"
          href="https://github.com/KarimDarrag"
        >
          &nbsp;
          <i class="fa fa-github" style={{ "font-size": "30px" }}></i>
        </a>
      </div>
    </nav>
  );
};

export default navbar;
